module.exports = __webpack_public_path__ + "img/round-arrow-right-light-blue-negative.6e2f8471.svg";